import { render } from "./native_modals.vue?vue&type=template&id=7c152bc1"
import script from "./native_modals.vue?vue&type=script&lang=js"
export * from "./native_modals.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__